import { TableProps } from '@amzn/awsui-components-core';
import { ApplicationDropdowns, LabelInput } from 'src/components/context/AppContextModels';

export interface FlattenedMetadataItem {
  id: string;
  labelType: string;
  label: string;
}

/**
 * Transforms ApplicationDropdowns into a flattened array suitable for table display
 * Each individual metadata item becomes a separate row
 */
export const transformDropdownsToTableData = (dropdowns: ApplicationDropdowns): FlattenedMetadataItem[] => {
  const tableData: FlattenedMetadataItem[] = [];

  // Map each dropdown category to individual rows
  const categoryMappings: Array<{ key: keyof ApplicationDropdowns; labelType: string }> = [
    { key: 'listApplicationOwners', labelType: 'ApplicationOwner' },
    { key: 'listGLAccounts', labelType: 'GLAccount' },
    { key: 'listToolUI', labelType: 'ToolUI' },
    { key: 'listAccessLevels', labelType: 'AccessLevel' },
    { key: 'listTimeGranularity', labelType: 'TimeGranularity' },
    { key: 'listKeyDimension', labelType: 'KeyDimension' },
    { key: 'listLastEnhanced', labelType: 'LastEnhanced' },
    { key: 'listProcess', labelType: 'Process' },
    { key: 'listScenario', labelType: 'Scenario' }
  ];

  categoryMappings.forEach(({ key, labelType }) => {
    const items = dropdowns[key] || [];
    items.forEach((item: LabelInput) => {
      tableData.push({
        id: item.id,
        labelType: labelType,
        label: item.label
      });
    });
  });

  // Sort by labelType
  return tableData.sort((a, b) => a.labelType.localeCompare(b.labelType));
};

/**
 * Column definitions for the flattened metadata table
 */
export const getMetadataTableColumns = (): TableProps.ColumnDefinition<FlattenedMetadataItem>[] => [
  {
    id: 'id',
    header: 'ID',
    cell: (item) => item.id,
    sortingField: 'id',
    isRowHeader: true,
    width: 200
  },
  {
    id: 'labelType',
    header: 'Label Type',
    cell: (item) => item.labelType,
    sortingField: 'labelType',
    width: 180
  },
  {
    id: 'label',
    header: 'Label',
    cell: (item) => item.label,
    sortingField: 'label'
  }
];

/**
 * Filter properties for the flattened metadata table
 */
export const getMetadataFilterProperties = () => [
  {
    key: 'id',
    operators: [':', '!:', '=', '!='],
    propertyLabel: 'ID',
    groupValuesLabel: 'ID values'
  },
  {
    key: 'labelType',
    operators: [':', '!:', '=', '!='],
    propertyLabel: 'Label Type',
    groupValuesLabel: 'Label Type values'
  },
  {
    key: 'label',
    operators: [':', '!:', '=', '!='],
    propertyLabel: 'Label',
    groupValuesLabel: 'Label values'
  }
];
